import { createContext } from "react";

export const cardGameContext = createContext(null);